import PropTypes from 'prop-types';
import React from 'react';

const ActionButton = ({ onHandleClick, enabled, children }) => (
  enabled ? (
    <button type="button" onClick={onHandleClick} className="blue-btn">
      {children}
    </button>
  ) : (
    <div className="grey-btn">
      {children}
    </div>
  )
);

ActionButton.defaultProps = {
  onHandleClick: null
};
ActionButton.propTypes = {
  onHandleClick: PropTypes.func,
  enabled: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default ActionButton;
